import { render, staticRenderFns } from "./DigitalPromoTermsModal.vue?vue&type=template&id=2deb2614&"
import script from "./DigitalPromoTermsModal.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2deb2614')) {
      api.createRecord('2deb2614', component.options)
    } else {
      api.reload('2deb2614', component.options)
    }
    module.hot.accept("./DigitalPromoTermsModal.vue?vue&type=template&id=2deb2614&", function () {
      api.rerender('2deb2614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/digital-promo/DigitalPromoTermsModal.vue"
export default component.exports